import { render, staticRenderFns } from "./ModalListView.vue?vue&type=template&id=5c4c7a87&scoped=true"
import script from "./ModalListView.vue?vue&type=script&lang=js"
export * from "./ModalListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4c7a87",
  null
  
)

export default component.exports